import { Outlet } from 'react-router-dom'

export const ProductsLayout = () => {
    return (
        <div className='flex min-h-[calc(100vh-100px)] min-w-0 w-full flex-1'>
            <Outlet />
        </div>
    )
}
